import list from './list'
export default {
  list,
}



// WEBPACK FOOTER //
// ./src/api/apis/self/salesContracts/index.js